
import React, { Fragment } from 'react';
import { Dialog, Grid, } from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import './style.css'
import Contact from './contact';
import Services from '../../api/service'


const ServiceSingle = ({ maxWidth, open, onClose, title, dImg, sImg1, sImg2, }) => {

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <i className="fa fa-close"></i>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });


    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                className="modalWrapper quickview-dialog"
                maxWidth={maxWidth}
            >
                <DialogTitle id="customized-dialog-title" onClose={onClose}>

                </DialogTitle>
                <Grid className="modalBody modal-body">
                    <div className="wpo-service-single-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-12">
                                    <div className="wpo-service-single-wrap">
                                        <div className="wpo-service-single-item">
                                            <div className="wpo-service-single-main-img">
                                                <img src={dImg} alt="" />
                                            </div>
                                            <div className="wpo-service-single-title">
                                                <h3>{title}</h3>
                                            </div>
                                            <p>I create visually compelling and strategic designs that help brands communicate their story effectively. From digital and print media to marketing materials, my focus is on blending creativity with purpose — ensuring every design captures attention and drives engagement.
                                                Each project is crafted to reflect your brand’s personality, resonate with your audience, and strengthen your visual identity across all platforms.</p>
                                            <div className="row mt-4">
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img src={sImg1} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img src={sImg2} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wpo-service-single-item list-widget">
                                            <div className="wpo-service-single-title">
                                                <h3>Our Capabilities</h3>
                                            </div>
                                            <p>Delivering creative logo, brand, and marketing designs that strengthen visual
                                                identity.From digital to print, I craft consistent, on-brand visuals for
                                                global impact.</p>
                                            <ul>
                                                <li>Creative logo and brand design for strong visual identity.</li>
                                                <li>Marketing and advertising materials for global audiences.</li>
                                                <li>Social media graphics and content design.</li>
                                                <li>Print and packaging design for digital and physical campaigns.</li>
                                                <li>Consistent, on-brand visuals across all platforms.</li>
                                            </ul>
                                        </div>
                                        <div className="wpo-service-single-item">
                                            <div className="wpo-service-single-title">
                                                <h3>Our approach</h3>
                                            </div>
                                            <p>My design process combines research, creativity, and attention to detail. I 
                                                begin by understanding your brand’s vision and target audience, then translate
                                                 that into visuals that align with your goals. Every concept is refined to 
                                                 ensure clarity, balance, and visual impact — resulting in designs that not 
                                                 only look great but perform effectively in real-world use.</p>
                                        </div>
                                        <div className="wpo-service-single-item list-widget">
                                            <div className="wpo-service-single-title">
                                                <h3>Our Work Process</h3>
                                            </div>
                                            <ul>
                                                <li>Understand your brand vision and creative goals.</li>
                                                <li>Research competitors and target audience trends.</li>
                                                <li>Develop unique design concepts and directions.</li>
                                                <li>Deliver high-quality assets ready for global use.</li>
                                            </ul>
                                        </div>
                                        <div className="wpo-service-single-item">
                                            <div className="wpo-service-single-title">
                                                <h3>Related Service</h3>
                                            </div>
                                            <div className="wpo-service-area">
                                                <div className="row align-items-center">
                                                    {Services.slice(0, 3).map((service, srv) => (
                                                        <div className="col-lg-4 col-md-6 col-12" key={srv}>
                                                            <div className="wpo-service-item">
                                                                <i className={`fi ${service.icon}`} ></i>
                                                                <h2>{service.sTitle}</h2>
                                                                <p>Lacus, etiam sed est eu tempus need Temer diam congue.</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wpo-service-single-item">
                                            <div className="wpo-service-contact-area">
                                                <div className="wpo-contact-title">
                                                    <h2>Have project in mind? Let's discuss</h2>
                                                    <p>Get in touch with us to see how we can help you with your project</p>
                                                </div>
                                                <div className="wpo-contact-form-area">
                                                    <Contact />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Dialog>
        </Fragment>
    );
}
export default ServiceSingle

